import { useContext } from 'react';

import { TemplatesStoreContext } from './store-context';

const useTemplatesStore = () => useContext(TemplatesStoreContext);

export default useTemplatesStore;
